import React from 'react'

const EditIcon = ({ ...props }) => (
  <div {...props}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.8" cx="20" cy="20" r="20" fill="#38C7AD" />
      <path
        d="M27.8333 19.0385C27.3725 19.0385 27 19.4119 27 19.8718V26.5385C27 26.9977 26.6266 27.3718 26.1667 27.3718H14.5C14.0399 27.3718 13.6667 26.9977 13.6667 26.5385V14.8718C13.6667 14.4127 14.0399 14.0385 14.5 14.0385H21.1667C21.6275 14.0385 22 13.6652 22 13.2053C22 12.7452 21.6275 12.3718 21.1667 12.3718H14.5C13.1217 12.3718 12 13.4935 12 14.8718V26.5385C12 27.9169 13.1217 29.0385 14.5 29.0385H26.1667C27.545 29.0385 28.6667 27.9169 28.6667 26.5385V19.8718C28.6667 19.411 28.2941 19.0385 27.8333 19.0385Z"
        fill="white"
      />
      <path
        d="M19.8133 18.2794C19.755 18.3376 19.7158 18.4118 19.6991 18.4918L19.11 21.4385C19.0825 21.5751 19.1258 21.7159 19.2241 21.8151C19.3033 21.8943 19.41 21.9367 19.5192 21.9367C19.5458 21.9367 19.5734 21.9343 19.6009 21.9285L22.5467 21.3394C22.6284 21.3226 22.7025 21.2835 22.76 21.2251L29.3534 14.6317L26.4075 11.686L19.8133 18.2794Z"
        fill="white"
      />
      <path
        d="M31.39 9.64846C30.5776 8.83593 29.2559 8.83593 28.4441 9.64846L27.2908 10.8017L30.2367 13.7476L31.39 12.5942C31.7833 12.2017 32 11.6783 32 11.1217C32 10.5651 31.7833 10.0417 31.39 9.64846Z"
        fill="white"
      />
    </svg>
  </div>
)

export default EditIcon
